import { EventEmitter } from 'events';

export default class Emitter {
  private static instance: EventEmitter;

  private constructor() {
    Emitter.instance = new EventEmitter();
  }

  public static getInstance(): EventEmitter {
    if (!Emitter.instance) {
      Emitter.instance = new EventEmitter();
    }

    return Emitter.instance;
  }
}
